module.exports = __webpack_public_path__ + "img/3lr.793bba70.svg";